import React from 'react'
import DataSource from '../DataSource'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import GlobalRoamingForm from '../forms/GlobalRoamingForm'
import ThingsToKnow from './ThingsToKnow'
import globals from '../globals'
import { NETWORK_TELSTRA } from '../constants'
import GlobalRoamingTelstraForm from '../forms/GlobalRoamingTelstraForm'

class GlobalRoaming extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            fields: {}
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getRoamingData/${this.props.serviceId}`, result => {
            this.setState(result)
            this.setState({ isLoaded: true })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    isTelstra () {
        return this.props.serviceDetails && this.props.serviceDetails.networkProvider === NETWORK_TELSTRA
    }

    render () {
        return (
            <div>
                <div className='buy-usage-data module' style={{ overflow: 'visible' }}>
                    <Heading title={this.props.title} />
                    <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2 text-center'>
                                <p>When you travel overseas from Australia your mobile data usage and voice calls are charged at much higher international roaming rates. The rate you pay will vary from country to country. You can switch Global Roaming for both Data and Voice on and off here.</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2'>
                                {this.isTelstra()
                                    ? <GlobalRoamingTelstraForm
                                            serviceId={this.props.serviceId}
                                            mobile={this.props.mobile}
                                            fields={this.state.fields}
                                            handleSuccess={() => globals.pushEvent('MobileUpdateGlobalRoaming')}
                                      />
                                    : <GlobalRoamingForm
                                        serviceId={this.props.serviceId}
                                        mobile={this.props.mobile}
                                        fields={this.state.fields}
                                        handleSuccess={() => globals.pushEvent('MobileUpdateGlobalRoaming')}
                                    />}
                            </div>
                        </div>
                    </ModuleWithLoader>
                </div>
                <ThingsToKnow type='globalRoaming' />
            </div>
        )
    }
}

export default GlobalRoaming



// WEBPACK FOOTER //
// ./resources/js/modules/GlobalRoaming.js